
/**
 *
 * NOTICE OF LICENSE
 *
 * This source file is released under commercial license by Lamia Oy.
 *
 * @copyright Copyright (c) Lamia Oy (https://lamia.fi)
 *
 */

export default {
    name: 'OpusTitle',
    props: {
        /**
         * Which tag component should use for rendering. Allowed tags: h1-h6 and span
         */
        tag: {
            type: String,
            required: false,
            default: 'h2',
            validator(tag) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'].indexOf(tag) !== -1;
            },
        },
        size: {
            type: String,
            default: 'h2',
            required: false,
            validator(tag) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'].indexOf(tag) !== -1;
            },
        },
        /**
         * Render className for text alignment. Allowed values: left, center, right
         */
        textAlign: {
            type: String,
            default: 'center',
            required: false,
            validator(textAlign) {
                return ['left', 'center', 'right'].indexOf(textAlign) !== -1;
            },
        },
        /**
         * Content of the title
         */
        content: {
            type: String,
            required: false,
            default: '',
        },
    },
    render(h) {
        const map = {
            h1: 'font-extrabold text-3xl lg:text-4xl',
            h2: 'font-extrabold text-2xl lg:text-3xl',
            h3: 'font-bold text-xl lg:text-2xl',
            h4: 'font-semibold text-base lg:text-xl lg:font-bold',
            h5: 'font-extrabold text-lg',
        };
        const data = {
            class: {
                [this.tag]: true,
                [`text--${this.textAlign}`]: true,
                [map[this.size]]: true,
            },
        };

        return h(this.tag, data, [this.content || this.$slots.default]);
    },
};
